var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"color":"gainsboro"}},[_c('span',[_vm._v(_vm._s(_vm.pv))]),_vm._v(" visits ")]),_c('div',{staticStyle:{"color":"gainsboro"}},[_c('span',[_vm._v(_vm._s(_vm.download))]),_vm._v(" downloads ")]),_c('div',{ref:"myEchart",staticClass:"myEchart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }